var render = function render(){var _vm=this,_c=_vm._self._c;return _c('base-uploader',{attrs:{"async":_vm.async,"type":_vm.type},on:{"onSuccess":_vm.onSuccess,"onError":_vm.onError,"onProgress":_vm.onProgress}})
}
var staticRenderFns = []

export { render, staticRenderFns }